import styled from "@emotion/styled";
import { Button } from "@mui/material";

export const AddGlobalsButton = styled(Button)({
	display: "flex",
	alignItems: "center",
	gap: "8px",
	fontWeight: 600,
	margin: 0,
	verticalAlign: "middle",
	letterSpacing: ".4px",
	lineHeight: "24px",
	textTransform: "uppercase"
});

export const AutoCompleteContainer = styled.div(({ theme }) => ({
	display: "grid",
	gap: 16,
	"& > div:last-of-type": {
		...theme.project.typography.caption,
		margin: 0
	}
}));

export const CustomColorFinishOptionDivider = styled.li(({ theme }) => ({
	...theme.project.typography.body.body2,
	div: {
		margin: "8px 16px"
	},
	color: theme.project.colors.fontColors.main,
	"& .MuiDivider-root": {
		color: theme.project.colors.fontColors.main,
		margin: 0
	}
}));

export const AllFieldsRequired = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));

export const Description = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary,
	paddingLeft: 24,
	paddingRight: 24,
	paddingTop: 4
}));

export const SelectionDetails = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main,
	fontSize: "0.875rem",
	lineHeight: "200%",
	div: {
		display: "flex",
		gap: 4
	}
}));

export const GlobalsSummaryContainer = styled.div({
	display: "flex",
	flexDirection: "column"
});

export const GlobalsSummaryField = styled.div({
	display: "flex",
	flexDirection: "row",
	gap: 4
});

export const GlobalsSummaryFieldLabel = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.fontColors.main
}));

export const GlobalsSummaryFieldValue = styled.div(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.fontColors.secondary
}));
